import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase/firebaseConfig';
import { ref, query, orderByChild, equalTo, onValue } from 'firebase/database';
import './Resume.css';

function Resume() {
  const { profileId } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const demoProfile = {
    name: "Aditya Agarwal",
    bio: "Frontend Developer",
    email: "adityaagarwal12@gmail.in",
    phone: "+91 2356787xxx",
    linkedin: "https://linkedin.com/aditya_agarwal",
    githubUsername: "aditya2312",
    summary: "Professional Memberships: - Member, Association for Computing Machinery (ACM) - Participant, Tech Conferences and Hackathons",
    otherInfo: "References: Available upon request.",
    projects: [
      {
        title: "E-commerce Platform",
        link: "https://link.com",
        github: "https://github.com/aditya2312/e-com",
        tech: "React.js, Node.js, MongoDB, Express.js",
        bullets: [
          "Developed a full-stack e-commerce platform using MERN stack.",
          "Integrated payment gateways and implemented user authentication.",
          "Technologies: React.js, Node.js, MongoDB, Express.js."
        ]
      },
      {
        title: "Task Management App",
        link: "https://leas.com",
        github: "https://github.com/aditya2312/tm-app",
        tech: "React.js, Node.js, WebSocket",
        bullets: [
          "Created a task management application with real-time collaboration features.",
          "Utilized WebSocket for real-time updates.",
          "Technologies: React.js, Node.js, WebSocket."
        ]
      }
    ],
    education: [
      { degree: "Bachelor of Science in Computer Science", school: "Tech University, Tech City, TC", year: "2015 - 2019" },
      { degree: "M-Tech", school: "Tech University, Tech City, TC", year: "2019 - 2021" }
    ],
    experience: [
      {
        role: "Frontend Developer",
        company: "Amazon",
        link: "https://amazon.in.co/aditya",
        duration: "2023 - 2027",
        bullets: ["Experienced frontend developer focused on scalable UI systems."]
      }
    ],
    achievements: ["Tech Excellence Award | Tech University | May 20XX"],
    profileId: "demo",
    suid: "DEMO_PORTAL_ACTIVE"
  };

  useEffect(() => {
    if (profileId === 'demo') {
      setProfile(demoProfile);
      setLoading(false);
      return;
    }

    const profileRef = query(ref(db, "users"), orderByChild("profileId"), equalTo(profileId));
    const unsubscribe = onValue(profileRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const firstKey = Object.keys(data)[0];
        setProfile(data[firstKey]);
      } else {
        setProfile(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [profileId]);

  if (loading) return (
    <div className="resume-loading">
      <div className="resume-spinner"></div>
      <p>Synchronizing Professional Record...</p>
    </div>
  );

  if (!profile) return <div className="resume-error">Profile Not Found</div>;

  return (
    <div className="resume-v4-container">
      <div className="resume-actions no-print">
        <button onClick={() => window.print()} className="btn btn-primary">
          <i className="fa-solid fa-print"></i> Generate PDF
        </button>
        <button onClick={() => window.location.href = '/'} className="btn btn-secondary">
          <i className="fa-solid fa-house"></i> {profileId === 'demo' ? 'Welcome Portal' : 'Dashboard'}
        </button>
      </div>

      <div className="resume-v4-paper">
        <header className="resume-v4-header">
            <div className="header-info">
                <h1 className="name-v4">{profile.name}</h1>
                <p className="title-v4">{profile.bio || "Full Stack Developer"}</p>
                <div className="contact-v4">
                   <div className="contact-row">
                      <div className="contact-item-v4"><i className="fa-solid fa-at"></i> {profile.email}</div>
                      <div className="contact-item-v4"><i className="fa-solid fa-phone"></i> {profile.phone || "+91 XXXXX XXXXX"}</div>
                   </div>
                   <div className="contact-row">
                      {profile.linkedin && <div className="contact-item-v4"><i className="fa-brands fa-linkedin"></i> {profile.linkedin}</div>}
                      <div className="contact-item-v4"><i className="fa-brands fa-github-alt"></i> github.com/{profile.githubUsername || profile.profileId}</div>
                   </div>
                </div>
            </div>
            <div className="header-photo">
                {profile.avatar ? (
                <img src={profile.avatar} alt="Profile" className="avatar-v4" />
                ) : (
                <div className="avatar-placeholder-v4"><i className="fa-solid fa-user"></i></div>
                )}
            </div>
        </header>

        <div className="resume-v4-content">
            <div className="col-v4 left-col-v4">
                <section className="section-v4">
                    <h2 className="section-title-v4">Projects</h2>
                    <div className="project-list-v4">
                        {(profile.projects || []).map((proj, idx) => (
                        <div key={idx} className="entry-v4">
                            <h3 className="entry-title-v4">{proj.title}</h3>
                            <div className="entry-links-v4">
                                {proj.link && <a href={proj.link} target="_blank" rel="noreferrer"><i className="fa-solid fa-link"></i> {proj.link}</a>}
                                {proj.github && <a href={proj.github} target="_blank" rel="noreferrer"><i className="fa-brands fa-github"></i> {proj.github}</a>}
                            </div>
                            {proj.tech && <p className="entry-tech-v4"><strong>{proj.tech}</strong></p>}
                            <ul className="entry-bullets-v4">
                                {(proj.bullets || [proj.desc]).map((bullet, bidx) => (
                                    <li key={bidx}>{bullet}</li>
                                ))}
                            </ul>
                        </div>
                        ))}
                    </div>
                </section>
                <section className="section-v4">
                    <h2 className="section-title-v4">Education</h2>
                    <div className="edu-list-v4">
                        {(profile.education || []).map((edu, idx) => (
                        <div key={idx} className="entry-v4">
                            <h3 className="entry-title-v4">{edu.degree}</h3>
                            <p className="entry-org-v4">{edu.school}</p>
                            <p className="entry-meta-v4"><i className="fa-solid fa-calendar-days"></i> {edu.year}</p>
                        </div>
                        ))}
                    </div>
                </section>
                <section className="section-v4">
                    <h2 className="section-title-v4">Summary</h2>
                    <p className="summary-text-v4">{profile.summary || "Professional record authenticated via DevTracker Neural Oversight."}</p>
                </section>
            </div>

            <div className="col-v4 right-col-v4">
                <section className="section-v4">
                    <h2 className="section-title-v4">Work Experience</h2>
                    <div className="work-list-v4">
                        {(profile.experience || []).map((exp, idx) => (
                        <div key={idx} className="entry-v4">
                            <h3 className="entry-title-v4">{exp.role}</h3>
                            <p className="entry-org-v4">{exp.company}</p>
                            {exp.link && <div className="entry-links-v4"><a href={exp.link} target="_blank" rel="noreferrer"><i className="fa-solid fa-link"></i> {exp.link}</a></div>}
                            <p className="entry-meta-v4"><i className="fa-solid fa-calendar-days"></i> {exp.duration}</p>
                            <ul className="entry-bullets-v4">
                                {(exp.bullets || [exp.desc]).map((bullet, bidx) => (
                                    <li key={bidx}>{bullet}</li>
                                ))}
                            </ul>
                        </div>
                        ))}
                    </div>
                </section>
                <section className="section-v4">
                    <h2 className="section-title-v4">Achievements</h2>
                    <div className="awards-v4">
                        {(profile.achievements || []).map((award, idx) => (
                            <div key={idx} className="award-item-v4">{award}</div>
                        ))}
                    </div>
                </section>
                <section className="section-v4">
                    <h2 className="section-title-v4">Other</h2>
                    <p className="other-text-v4">{profile.otherInfo || "References: Available upon request."}</p>
                </section>
            </div>
        </div>

        <footer className="resume-v4-footer">
            <div className="footer-left-v4">
                <p className="cert-v4">
                    <strong>AUTHENTIC_CREDENTIAL_ID:</strong> {profileId === 'demo' ? 'DEMO_0X_EA2B' : profile.profileId?.substring(0, 12).toUpperCase()} | 
                    <strong> SUID:</strong> {profile.suid || "PENDING_VERIFICATION"}
                </p>
                <p className="legal-v4">
                    This document is a system-verified asset from the <strong>DevTracker Neural Engine</strong>. 
                    Platforms authenticated on {new Date().toLocaleDateString()}.
                </p>
            </div>
            <div className="footer-right-v4">
                <div className="qr-v4">
                    <img src={`https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=${encodeURIComponent(window.location.origin + '/verify/' + profileId)}`} alt="Verify QR" />
                    <span>SCAN TO VERIFY</span>
                </div>
            </div>
        </footer>
      </div>
    </div>
  );
}

export default Resume;
